<template>
  <div>
    <v-dialog transition="none" scrollable v-model="dialog" width="auto">
      <v-card>
        <v-app-bar dense style="width: 100%; background-color: rgb(233, 10, 124);">
          <v-toolbar-title style="color: white" class="float-left">
            {{selectedBetContext}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
<!--              <v-switch-->
<!--                class="mt-5"-->
<!--                dark-->
<!--                v-model="betTimeSwitch"-->
<!--                :label="`Filter by Bet Time`"-->
<!--              >-->
<!--              </v-switch>-->
          <v-col class="text-right" style="padding: 0;">
<!--                <v-btn style="margin-right: 5px" disabled @click="exportPDF" dark color="#e84141">-->
<!--                  PDF-->
<!--                  <v-icon medium dark>mdi-download</v-icon>-->
<!--                </v-btn>-->
            <Filters :clearAllFilters="clearFilters" />
            <v-btn v-if="!csvExported" @click="exportCSV" class="mr-2" dark color="blue">CSV
              <v-icon medium dark>mdi-download</v-icon>
            </v-btn>
            <v-btn v-if="csvExported" disabled @click="exportCSV" class="mr-2" dark color="blue">CSV
              <v-icon medium dark>mdi-download</v-icon>
            </v-btn>
          </v-col>
          <v-btn class="float-right" icon small @click.stop="closeDialog">
            <v-icon class="white--text">mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-card-text>
          <race-table
            :key="componentKey"
            :summary="isBetBack"
            :dataTable="filteredBets"
            :headers="tableHeaders"
            :loading="betsLoading"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <div v-if="selectedRace || showMeeting">
      <div class="float-left mb-2" style="width: 49%;"
        v-if="meeting.meetingId">
        <div>
          <span class="subtitle-1">Race List: </span>
          <v-chip v-if="meeting.meetingDate" class="mr-1 petrol white--text">
            {{format(new Date(meeting.meetingDate), 'do MMM yy')}}
          </v-chip>
          <v-chip v-else-if="race.meetingDate" class="mr-1 petrol white--text">
            {{format(new Date(race.meetingDate), 'do MMM yy')}}
          </v-chip>
          <v-dialog transition="none"
            scrollable v-model="dialogAll" width="auto">
            <template v-slot:activator="{ on, attrs}">
              <v-btn
                small
                class="mr-2"
                style="background-color: rgb(233, 10, 124); float: right"
                dark
                v-bind="attrs"
                v-on="on"
              >
              Show Bets
              </v-btn>
            </template>
            <v-card>
              <v-app-bar dense style="width: 100%; background-color: rgb(233, 10, 124);">
                <v-toolbar-title style="color: white" class="float-left">
                  {{selectedBetContextTotal}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
<!--                    <v-switch-->
<!--                      class="mt-5"-->
<!--                      dark-->
<!--                      v-model="betTimeSwitch"-->
<!--                      :label="`Filter by Bet Time`"-->
<!--                    >-->
<!--                    </v-switch>-->
                <v-col class="text-right" style="padding: 0;">
<!--                      <v-btn style="margin-right: 5px" disabled @click="exportPDF" dark-->
<!--                        color="#e84141">-->
<!--                        PDF-->
<!--                        <v-icon medium dark>mdi-download</v-icon>-->
<!--                      </v-btn>-->
                  <Filters :clearAllFilters="clearFilters" />
                  <v-btn v-if="!csvExported" @click="exportCSV" class="mr-2" dark color="blue">CSV
                    <v-icon medium dark>mdi-download</v-icon>
                  </v-btn>
                  <v-btn v-if="csvExported" disabled @click="exportCSV" class="mr-2" dark color="blue">CSV
                    <v-icon medium dark>mdi-download</v-icon>
                  </v-btn>
                </v-col>
                <v-btn class="float-right" icon small @click.stop="closeDialogAll">
                  <v-icon class="white--text">mdi-close</v-icon>
                </v-btn>
              </v-app-bar>
              <v-card-text>
                <race-table
                  :key="componentKey"
                  :isMeeting="true"
                  :isBetBack="isBetBack"
                  :dataTable="filteredBets"
                  :headers="tableHeaders"
                  :loading="betsLoading"
                />
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </div>
      <div class="float-right mb-2" style="width: 50%;"
        v-if="meeting.meetingId">
        <div>
          <span class="subtitle-1">Selected Race: </span>
          <v-chip v-if="meeting.meetingDate" class="mr-1 petrol white--text">
            {{format(new Date(meeting.meetingDate), 'do MMM yy')}}
          </v-chip>
          <v-chip v-else-if="race.meetingDate" class="mr-1 petrol white--text">
            {{format(new Date(race.meetingDate), 'do MMM yy')}}
          </v-chip>
          <v-chip v-if="meeting.track" class="mr-1 petrol white--text"
          clearable>{{ meeting.track }}<v-btn icon x-small @click="clearSelections(),
          selectedAll()"><v-icon>mdi-close</v-icon></v-btn></v-chip>
          <v-chip  v-else-if="race.track"
          clearable class="mr-1 petrol white--text">{{ race.track }}<v-btn class="ml-2" icon x-small
          @click="clearSelections(),
          selectedAll()"><v-icon class="white--text" x-small>mdi-close</v-icon></v-btn></v-chip>
          <v-chip v-if="race.raceNumber" class="mr-1 petrol white--text">
            Race {{ race.raceNumber }} <v-btn icon x-small
          @click="handleRemoveRace(race), showMeeting=true, showRunner=false">
          <v-icon class="white--text ml-2" x-small>mdi-close</v-icon></v-btn></v-chip>
          <v-dialog transition="none" scrollable v-model="dialogRace" width="auto">
            <template v-slot:activator="{ on, attrs}">
              <v-btn
                small
                class="mr-2"
                style="background-color: rgb(233, 10, 124); float: right;"
                dark
                v-bind="attrs"
                v-on="on"
              >
              Show Bets
              </v-btn>
            </template>
            <v-card>
              <v-app-bar dense style="width: 100%; background-color: rgb(233, 10, 124);">
                <v-toolbar-title style="color: white" class="float-left">
                  {{selectedBetContextRace}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
<!--                    <v-switch-->
<!--                      class="mt-5"-->
<!--                      dark-->
<!--                      v-model="betTimeSwitch"-->
<!--                      :label="`Filter by Bet Time`"-->
<!--                    >-->
<!--                    </v-switch>-->
                <v-col class="text-right" style="padding: 0;">
<!--                      <v-btn style="margin-right: 5px" disabled @click="exportPDF" dark-->
<!--                        color="#e84141">-->
<!--                        PDF-->
<!--                        <v-icon medium dark>mdi-download</v-icon>-->
<!--                      </v-btn>-->
                  <Filters :clearAllFilters="clearFilters" />
                  <v-btn v-if="!csvExported" @click="exportCSV" class="mr-2" dark color="blue">CSV
                    <v-icon medium dark>mdi-download</v-icon>
                  </v-btn>
                  <v-btn v-if="csvExported" disabled @click="exportCSV" class="mr-2" dark color="blue">CSV
                    <v-icon medium dark>mdi-download</v-icon>
                  </v-btn>
                </v-col>
                <v-btn class="float-right" icon small @click.stop="closeDialogRace">
                  <v-icon class="white--text">mdi-close</v-icon>
                </v-btn>
              </v-app-bar>
              <v-card-text>
                <race-table
                  :key="componentKey"
                  :isRace="true"
                  :isBetBack="isBetBack"
                  :dataTable="filteredBets"
                  :headers="tableHeaders"
                  :loading="betsLoading"
                />
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </div>
      <div style="clear:both"></div>
      <RaceDetails :races="races"
        :bookiesrace="bookiesrace"
        :items="bookies"
        :dataTableHeight="dataTableHeight"
        style="width: 49%; float: left" />
      <RunnerDetails
        v-if="showRunner"
        style="width: 50%; float: right;"
        @dialog="dialog = true"
        :runners="runners"
        :dataTableHeight="dataTableHeight"
      />
      <RaceDetails
        v-if="showMeeting"
        :races="secondRaces"
        :bookiesrace="bookiesrace"
        :items="bookies"
        :dataTableHeight="dataTableHeight"
        style="width: 50%; float: right" />
    </div>
    <div v-else>
      <div
        v-if="meeting.meetingId" class="mb-2">
        <span class="subtitle-1">Race List: </span>
        <v-chip v-if="meeting.meetingDate" class="mr-1 petrol white--text">
          {{format(new Date(meeting.meetingDate), 'do MMM yy')}}
        </v-chip>
        <v-chip v-else-if="race.meetingDate" class="mr-1 petrol white--text">
          {{format(new Date(race.meetingDate), 'do MMM yy')}}
        </v-chip>
        <v-chip v-if="meeting.track" class="mr-1 petrol white--text">{{ meeting.track }}
          <v-btn icon class="ml-2" x-small @click="clearSelections(),
        selectedAll()"><v-icon class="white--text" x-small>mdi-close</v-icon></v-btn></v-chip>
        <v-chip v-else-if="race.track" class="mr-1 petrol white--text">{{ race.track }}
          <v-btn class="ml-2" icon x-small @click="clearSelections(),
        selectedAll()"><v-icon class="white--text" x-small>mdi-close</v-icon></v-btn></v-chip>
        <v-dialog transition="none"
          scrollable v-model="dialogMeeting" width="auto">
          <template v-slot:activator="{ on, attrs}">
            <v-btn
              small
              class="mr-2"
              style="background-color: rgb(233, 10, 124); float: right"
              dark
              v-bind="attrs"
              v-on="on"
            >
            Show Bets
            </v-btn>
          </template>
          <v-card>
            <v-app-bar dense style="width: 100%; background-color: rgb(233, 10, 124);">
              <v-toolbar-title style="color: white" class="float-left">
                {{selectedBetContext}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
<!--                  <v-switch-->
<!--                    class="mt-5"-->
<!--                    dark-->
<!--                    v-model="betTimeSwitch"-->
<!--                    :label="`Filter by Bet Time`"-->
<!--                  >-->
<!--                  </v-switch>-->
              <v-col class="text-right" style="padding: 0;">
<!--                    <v-btn style="margin-right: 5px" @click="exportPDF" disabled dark-->
<!--                      color="#e84141">-->
<!--                      PDF-->
<!--                      <v-icon medium dark>mdi-download</v-icon>-->
<!--                    </v-btn>-->
                <Filters :clearAllFilters="clearFilters" />
                <v-btn v-if="!csvExported" @click="exportCSV" class="mr-2" dark color="blue">CSV
                  <v-icon medium dark>mdi-download</v-icon>
                </v-btn>
                <v-btn v-if="csvExported" disabled @click="exportCSV" class="mr-2" dark color="blue">CSV
                  <v-icon medium dark>mdi-download</v-icon>
                </v-btn>
              </v-col>
              <v-btn class="float-right" icon small @click.stop="closeDialogMeeting">
                <v-icon class="white--text">mdi-close</v-icon>
              </v-btn>
            </v-app-bar>
            <v-card-text>
              <race-table
                :key="componentKey"
                :isMeeting="true"
                :isBetBack="isBetBack"
                :dataTable="filteredBets"
                :headers="tableHeaders"
                :loading="betsLoading"
              />
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
      <div class="subtitle-1 mb-3" v-else>Race List:
        <v-chip class="petrol white--text">{{selectedBetContextTotal}}</v-chip>
        <v-dialog transition="none" scrollable v-model="dialogAllRace" width="auto">
            <template v-slot:activator="{ on, attrs}">
              <v-btn
                small
                class="mr-2"
                style="background-color: rgb(233, 10, 124); float: right;"
                dark
                v-bind="attrs"
                v-on="on"
              >
              Show Bets
              </v-btn>
            </template>
            <v-card>
              <v-app-bar dense style="width: 100%; background-color: rgb(233, 10, 124);">
                <v-toolbar-title style="color: white" class="float-left">
                  {{selectedBetContext}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
<!--                    <v-switch-->
<!--                      class="mt-5"-->
<!--                      dark-->
<!--                      v-model="betTimeSwitch"-->
<!--                      :label="`Filter by Bet Time`"-->
<!--                    >-->
<!--                    </v-switch>-->
                <v-col class="text-right" style="padding: 0;">
<!--                      <v-btn style="margin-right: 5px" @click="exportPDF" disabled dark-->
<!--                        color="#e84141">-->
<!--                        PDF-->
<!--                        <v-icon medium dark>mdi-download</v-icon>-->
<!--                      </v-btn>-->
                  <Filters :clearAllFilters="clearFilters" />
                  <v-btn v-if="!csvExported" @click="exportCSV" class="mr-2" dark color="blue">CSV
                    <v-icon medium dark>mdi-download</v-icon>
                  </v-btn>
                  <v-btn v-if="csvExported" disabled @click="exportCSV" class="mr-2" dark color="blue">CSV
                    <v-icon medium dark>mdi-download</v-icon>
                  </v-btn>
                </v-col>
                <v-btn class="float-right" icon small @click.stop="closeDialogAllRace">
                  <v-icon class="white--text">mdi-close</v-icon>
                </v-btn>
              </v-app-bar>
              <v-card-text>
                <race-table
                  :key="componentKey"
                  :isRace="false"
                  :isMeeting="false"
                  :isBetBack="isBetBack"
                  :dataTable="getFilteredBets"
                  :headers="tableHeaders"
                  :loading="betsLoading"
                />
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
        <RaceDetails :allRaces="allRaces"
          :bookiesrace="bookiesrace"
          :items="bookies"
          :races="races" :dataTableHeight="dataTableHeight"/>
      </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { format } from 'date-fns'
import RunnerDetails from '../RunnerDetails'
import RaceDetails from '../RaceDetails'
import { loaders } from '../../store'
import { BOOKMAKER_NAMES_LOOKUP } from '../../common/constants'
import RaceTable, { constants } from '../RaceTable'
import Filters from '../Filters'

export default {
  name: 'DetailedView',
  data () {
    return {
      format,
      isBetBack: false,
      bottomContent: 'chart',
      dialogMeeting: false,
      dialogRace: false,
      dialogAllRace: false,
      dialogAll: false,
      dialog: false,
      showRunner: true,
      showMeeting: false,
      componentKey: 0,
      betTimeSwitch: false,
      csvExported: false,
      panel: 0,
      clearFilters: false
    }
  },
  props: {
    dataTableHeight: Number
  },
  mounted () {
    this.fetchMeetings()
    // this.fetchBookieBets()
    this.fetchAllBookies()
    this.fetchBookieRace()
  },
  watch: {
    selectedRace (next, prev) {
      this.fetchBookieRace()
      const prevRace = (prev && prev?.race_number) || 0
      const nextRace = (next && next?.race_number) || 0

      if (nextRace === prevRace || !nextRace) {
        return
      }
      if (this.runners) {
        this.$store.commit('clearRunners')
      }
      this.fetchRunners()
      this.showRunner = true
      this.showMeeting = false
    },
    selectedDate () {
      this.$store.commit('clearRunners')
    },

    betTimeSwitch () {
      this.setSortByBetTime(this.betTimeSwitch)
      if (this.dialog === true) {
        this.forceRerender()
        this.fetchBets({ pagination: { page: 1, limit: 100 }, filtered: true })
      }
      if (this.dialogMeeting === true) {
        this.forceRerender()
        this.fetchBetsMeeting({ overrides: { pagination: { page: 1, limit: 100 }, filtered: true } })
      }
      if (this.dialogRace === true) {
        this.forceRerender()
        this.fetchBetsRace({ overrides: { pagination: { page: 1, limit: 100 }, filtered: true } })
      }
      if (this.dialogAllRace === true) {
        this.forceRerender()
        this.fetchBetSummary({
          medium: 'none',
          infoType: 'none',
          betType: 'none',
          source: 'none',
          betId: '',
          clientRef: '',
          raceNumber: '',
          runnerNumber: '',
          time: '',
          country: 'none',
          meetingType: 'none',
          state: 'none',
          clearFilteredBets: false,
          meetingId: '',
          runnersArray: '',
          betBack: 'none',
          sortFields: {},
          overrides: { pagination: { page: 1, limit: 100 }, filtered: true }
        })
      }
      if (this.dialogAll === true) {
        this.forceRerender()
        if (this.selectedDate) {
          this.fetchBetsMeeting({ overrides: { pagination: { page: 1, limit: 100 }, filtered: true } })
        } else {
          this.fetchBetsAll({ pagination: { page: 1, limit: 100 }, filtered: true })
        }
      }
    },

    dialog (open, close) {
      if (open) {
        this.clearFilteredBets()
        this.clearChildBets()
        this.forceRerender()
        this.fetchBets({ pagination: { page: 1, limit: 100 }, filtered: true })
        this.clearFiltersBy(false)
      } else if (close) {
        this.clearFilters = true
        this.clearExportFilters()
        this.clearFiltersApplied()
      }
    },
    dialogMeeting (open, close) {
      if (open) {
        this.clearFilteredBets()
        this.clearChildBets()
        this.forceRerender()
        this.fetchBetsMeeting({ overrides: { pagination: { page: 1, limit: 100 }, filtered: true } })
        this.clearFiltersBy(false)
      } else if (close) {
        this.clearFilters = true
        this.clearExportFilters()
        this.clearFiltersApplied()
      }
    },
    dialogRace (open, close) {
      if (open) {
        this.clearFilteredBets()
        this.clearChildBets()
        this.forceRerender()
        this.fetchBetsRace({ overrides: { pagination: { page: 1, limit: 100 }, filtered: true } })
        this.clearFiltersBy(false)
      } else if (close) {
        this.clearFilters = true
        this.clearExportFilters()
        this.clearFiltersApplied()
      }
    },
    dialogAllRace (open, close) {
      if (open) {
        this.clearFilteredBets()
        this.clearChildBets()
        this.forceRerender()
        this.fetchBetSummary({
          medium: 'none',
          infoType: 'none',
          betType: 'none',
          source: 'none',
          betId: '',
          clientRef: '',
          raceNumber: '',
          runnerNumber: '',
          time: '',
          country: 'none',
          meetingType: 'none',
          state: 'none',
          clearFilteredBets: false,
          meetingId: '',
          runnersArray: '',
          betBack: 'none',
          sortFields: {},
          overrides: { pagination: { page: 1, limit: 100 }, filtered: true }
        })
        this.clearFiltersBy(false)
      } else if (close) {
        this.clearFilters = true
        this.clearExportFilters()
        this.clearFiltersApplied()
      }
    },
    dialogAll (open, close) {
      if (open) {
        this.clearFilteredBets()
        this.clearChildBets()
        this.forceRerender()
        if (this.selectedDate) {
          this.fetchBetsMeeting({ overrides: { pagination: { page: 1, limit: 100 }, filtered: true } })
        } else {
          this.fetchBetsAll({ pagination: { page: 1, limit: 100 }, filtered: true })
        }
        this.clearFiltersBy(false)
      } else if (close) {
        this.clearFilters = true
        this.clearExportFilters()
        this.clearFiltersApplied()
      }
    }
  },
  methods: {
    ...mapActions(['fetchData', 'fetchAllBookies', 'clearExportFilters', 'setSelectedCountry', 'setSelectedState', 'clearMeetingType', 'updateAllRaces', 'updateNoRacesAvail', 'setDarkMode', 'setSortByBetTime', 'fetchSecondMeetings', 'fetchCountryRaces', 'clearSelections', 'clearSelectedRace', 'setSelectedRunner', 'setSelectedRace', 'fetchBetSummary', 'fetchBetsAll', 'fetchBetsRace', 'fetchBetsMeeting', 'setSelectedFormat', 'exportBets', 'setPage', 'fetchBetsByType', 'setSelectedDate', 'fetchRacesDated', 'setSelectedMeeting', 'fetchBookieBets', 'clearSelections', 'clearSelectedRace', 'fetchBookieBetsDated', 'fetchAllRaces', 'setItemsPerPage', 'setError', 'fetchBookieRace', 'fetchBetBacks', 'fetchRunners', 'fetchMeetings', 'fetchBookies', 'fetchBets', 'fetchRaces', 'fetchBookieBets', 'fetchAccess', 'clearFilteredBets', 'clearChildBets', 'setRestartPagination', 'clearFiltersApplied', 'clearFiltersBy']),
    closeDialogAll () {
      this.clearFilteredBets()
      this.dialogAll = false
      this.csvExported = false
    },
    closeDialogRace () {
      this.clearFilteredBets()
      this.dialogRace = false
      this.csvExported = false
    },
    closeDialogMeeting () {
      this.clearFilteredBets()
      this.dialogMeeting = false
      this.csvExported = false
    },
    closeDialog () {
      this.clearFilteredBets()
      this.dialog = false
      this.csvExported = false
    },
    closeDialogAllRace () {
      this.clearFilteredBets()
      this.dialogAllRace = false
      this.csvExported = false
    },
    getChartColor (betType) {
      switch (betType) {
        case 'win':
          return '#f56a79'
        case 'place':
          return '#1aa6b7'
        default:
          return 'black'
      }
    },
    forceRerender () {
      this.componentKey += 1
    },
    handleDateClick (date) {
      this.setSelectedDate(date)
    },
    exportPDF () {
      this.setSelectedFormat('Pdf')
      this.exportBets()
    },
    exportCSV () {
      this.setSelectedFormat('Csv')
      this.exportBets(this.exportFilters)
      this.csvExported = true
    },
    handleRemoveRace (meeting) {
      this.$store.commit('clearRunners')
      this.setSelectedMeeting(meeting)
      this.clearSelectedRace()
      this.fetchSecondMeetings()
    },
    selectedAll () {
      this.showMeeting = false
      this.updateAllRaces(true)
      this.updateNoRacesAvail(false)
      this.$store.commit('clearRunners')
    },
    choiceOfBookie () {
      return BOOKMAKER_NAMES_LOOKUP[this.selectedBookie]
    }
  },
  components: {
    RunnerDetails,
    RaceDetails,
    RaceTable,
    Filters
  },
  computed: {
    ...mapState(['error', 'exportFilters', 'allRaces', 'darkModeST', 'user', 'runners', 'access', 'dateOf', 'loggedIn', 'selectedMeeting', 'selectedRunner', 'bookies', 'bookiesrace', 'betbacks', 'filteredBetBacks', 'selectedBookie', 'selectedDate', 'bets', 'races', 'secondRaces', 'filteredBets', 'selectedRace', 'loading']),
    ...mapGetters(['getPagination', 'getSelectedRace', 'getSelectedMeeting', 'getSelections', 'getDates', 'getDatesFormatted', 'getFilteredBets']),
    tableHeaders () {
      return constants.headers
    },
    betsLoading () {
      return this.loading[loaders.BETS]
    },
    selectedBetContext () {
      // eslint-disable-next-line camelcase
      const betCtx = `${this.selectedMeeting?.track || this.selectedRace?.track || ''} ${this.selectedRace?.raceNumber ? ` - Race ${this.selectedRace.raceNumber}` : ''} ${this.selectedRunner?.name ? `- Runner: ${this.selectedRunner.name}` : ''}`.trim()
      let meetingDate = this.getDatesFormatted.join(' ~ ')
      if (this.selectedMeeting?.meetingDate) {
        meetingDate = format(new Date(this.selectedMeeting?.meetingDate), 'do MMM yy')
      }
      return betCtx.length > 0 ? `Showing bets for ${betCtx} | ${meetingDate}` : `Showing bets for all meetings | ${meetingDate}`
    },
    selectedBetContextRace () {
      // eslint-disable-next-line camelcase
      const betCtx = `${this.selectedMeeting?.track || this.selectedRace?.track || ''} ${this.selectedRace?.raceNumber ? ` - Race ${this.selectedRace.raceNumber}` : ''}`.trim()
      let meetingDate = this.getDatesFormatted.join(' ~ ')
      if (this.selectedRace?.meetingDate) {
        meetingDate = format(new Date(this.selectedRace?.meetingDate), 'do MMM yy')
      }
      if (this.selectedMeeting?.meetingDate) {
        meetingDate = format(new Date(this.selectedMeeting?.meetingDate), 'do MMM yy')
      }
      return betCtx.length > 0 ? `Showing bets for ${betCtx} | ${meetingDate}` : `Showing bets for ${meetingDate}`
    },
    selectedBetContextMeeting () {
      // eslint-disable-next-line camelcase
      const betCtx = `${this.selectedMeeting?.track || this.selectedRace?.track || ''}`.trim()
      const meetingDate = format(new Date(this.selectedRace?.meetingDate), 'do MMM yy')
      return betCtx.length > 0 ? `Showing bets for ${betCtx} | ${meetingDate}` : `Showing bets for ${meetingDate}`
    },
    selectedBetContextTotal () {
      const betCtx = `${this.selectedMeeting?.track || this.selectedRace?.track || ''}`.trim()
      let meetingDate = this.getDatesFormatted.join(' ~ ')
      if (this.selectedRace?.meetingDate) {
        meetingDate = format(new Date(this.selectedRace?.meetingDate), 'do MMM yy')
      }
      if (this.selectedMeeting?.meetingDate) {
        meetingDate = format(new Date(this.selectedMeeting?.meetingDate), 'do MMM yy')
      }
      return betCtx.length > 0 ? `Showing bets for ${betCtx} | ${meetingDate}` : `Showing bets for ${meetingDate}`
    },
    race () {
      return this.getSelectedRace || {}
    },
    meeting () {
      return this.getSelectedMeeting || {}
    }
  }
}
</script>

<style scoped>
.spacer {
  height: 20px
}
.toolbar {
  grid-area: toolbar;
}
.dashboardTables {
  padding-top: 5px;
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 3;
  overflow-y: hidden;
  overflow-x: hidden;
}
.dashboard {
  display: grid;
  grid-template-rows: 70px auto;
  grid-template-columns: auto;
  grid-template-areas:
    "content";
}
.dashboard-header {
  grid-area: header;
}
.dashboardBookies {
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 2;
}
.dashboard-error {
  grid-area: error;
}
.dashboard-topMenu {
  grid-area: topMenu;
}
.dashboard-searchbar {
  grid-area: searchbar;
}
.dashboard-centerContent {
  grid-area: centerContent;
}
.dashboard-bottomContent {
  grid-area: bottomContent;
  height: 100%;
}
.bottomContent-buttons button {
  margin-right: 10px;
  margin-bottom: 5px;
}
.bottomContent-container-content {
  height: 90%;
}
</style>
